// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import LoaderWithText from "src/components/Loader";
import ServerError from "src/components/auth/ServerError";
import { getSignInError } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  displayName: string,
  email: string,
  isAuthenticationChecked: boolean,
  error: Object,
  orgFailure: Object,
  customMessage?: string,
};

const LoaderComponent = ({
  displayName,
  email,
  error,
  orgFailure,
  customMessage,
}: Props) => {
  const showError = error || orgFailure;
  return (
    <React.Fragment>
      {!showError && (
        <LoaderWithText>
          {customMessage && customMessage.length !== 0 ? (
            <span>{customMessage}</span>
          ) : (
            <>
              <span data-cy="loading">
                {i18n.t(k.LOADING_CONVERSATIONS_FOR)}
              </span>{" "}
              <b>{displayName || email}</b>
            </>
          )}
        </LoaderWithText>
      )}
      {showError && <ServerError />}
    </React.Fragment>
  );
};

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  error: getSignInError("sendAuthToken")(app),
  orgFailure: getSignInError("orgFailure")(app),
  ...props,
});

export default connect(mapStateToProps, {})(LoaderComponent);
